
<template>
    <!-- 手表列表 -->
    <div class="buttonlist">
      <div class="buttonlist-m">
        <el-form
          :inline="true"
          :model="formInline"
          class="demo-form-inline toolbar"
          style="padding-bottom: 0px"
          @submit.native.prevent
        >
          <el-form-item label="设备编号">
            <el-input
              v-model.trim="formInline.inputdeviceno"
              placeholder="请输入设备编号"
              clearable
              @keyup.enter.native.prevent="enterSearchMember"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              icon="el-icon-search" 
              plain
              @click="onSubmit"
              >查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button
              type="warning"
              plain
              class="el-icon-plus"
              @click="dialogFormVisible = true"
              >新增</el-button
            >
          </el-form-item>
        </el-form>
        <div v-loading="loading" element-loading-text="拼命加载中......">
        
          <el-table
            :data="list"
            style="width: 100%"
            :row-style="tableRowStyle"
            :header-cell-style="tableHeaderColor"
          >
            <el-table-column
              label="设备编号"
              align="center"
              :show-overflow-tooltip="true"
            >
              <template slot-scope="scope">
                <span style="margin-left: 10px">{{ scope.row.deviceNo }}</span>
              </template>
            </el-table-column>
          
            <el-table-column
              label="设备名称"
              :show-overflow-tooltip="true"
              align="center"
            >
              <template slot-scope="scope">
                <span style="margin-left: 10px">{{ scope.row.deviceName }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="设备描述"
              :show-overflow-tooltip="true"
              align="center"
            >
              <template slot-scope="scope">
                <span style="margin-left: 10px">{{ scope.row.remark }}</span>
              </template>
            </el-table-column>
  
            <el-table-column label="操作" width="350" align="center">
              <template slot-scope="scope">
                <el-button
                  type="primary"
                  size="mini"
                  plain
                  @click="handleEdit(scope.$index, scope.row)"
                  >编辑</el-button
                >
                <el-button
                  type="danger"
                  size="mini"
                  plain
                  @click="handleDelete(scope.$index, scope.row)"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            layout="total, prev, pager, next"
            :total="totalDataNumber"
            :page-size="pageSize"
            align="center"
            class="fenye"
          ></el-pagination>
        </div>
        <!-- 弹出新增 -->
        <el-dialog
          title="新增设备信息"
          :visible.sync="dialogFormVisible"
          :close-on-click-modal="false"
          :close-on-press-escape="false"
          class="dangerbuttonxz"
          @close="closexz"
        >
          <el-form ref="form" :model="form" :rules="rules">
            <el-form-item
              label="设备编号"
              :label-width="formLabelWidth"
              prop="xzdate"
            >
              <el-input
                v-model.trim="form.xzdate"
                placeholder="请输入设备编号"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="设备名称"
              :label-width="formLabelWidth"
              prop="xzname"
            >
              <el-input
                v-model.trim="form.xzname"
                placeholder="请输入设备名称"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="设备描述"
              :label-width="formLabelWidth"
              prop="xzsec"
            >
              <el-input
                v-model.trim="form.xzsec"
                type="textarea"
                :rows="3"
                placeholder="请输入设备描述"
              ></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer" align="center">
            <el-button @click="cancelxz">取 消</el-button>
            <el-button
              type="primary"
              @click="submitForm('form')"
              :loading="addLoading"
              >确 定</el-button
            >
          </div>
        </el-dialog>
  
        <!-- 弹出修改-->
        <el-dialog
          title="修改设备信息"
          :visible.sync="dialogFormEdit"
          :close-on-click-modal="false"
          :close-on-press-escape="false"
          class="dangerbuttonedit"
        >
          <el-form ref="formedit" :model="formedit" :rules="rules">
            <el-form-item
              label="设备编号"
              :label-width="formLabelWidth"
              prop="editdate"
            >
              <el-input
                disabled
                v-model.trim="formedit.editdate"
                auto-complete="off"
                placeholder="请输入设备编号"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="设备名称"
              :label-width="formLabelWidth"
              prop="editname"
            >
              <el-input
                v-model.trim="formedit.editname"
                auto-complete="off"
                placeholder="请输入设备名称"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="设备描述"
              :label-width="formLabelWidth"
              prop="editsec"
            >
              <el-input
                v-model.trim="formedit.editsec"
                auto-complete="off"
                type="textarea"
                :rows="3"
                placeholder="请输入设备描述"
              ></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer" align="center">
            <el-button @click="dialogFormEdit = false">取 消</el-button>
            <el-button
              type="primary"
              @click="submitFormEdit('formedit')"
              :loading="editLoading"
              >确 定</el-button
            >
          </div>
        </el-dialog>
  
      </div>
    </div>
  </template>
  <script>
  import bus from "@/vuex/eventBus"; //引入eventBus,接收子界面传递的跳转指令,然后在父界面跳转,添加tab
  export default {
    data() {
      return {
        selectOldmanList: [], //select下拉菜单的老人集合
        addLoading: false,
        editLoading: false,
        currentPage: 1, //初始页
        pageNum: 1, //页码
        pageSize: 10, //每页显示的条数
        deviceno: "",
        list: [], //返回的结果集合
        allList: [], //返回紧急按钮的集合  全部数据
        totalDataNumber: 0, //数据的总数,
        loading: "", //加载数据中
        oldmanNameIdList: [], //老人姓名和Id （用于下拉菜单展示老人以及绑定的时候 删除老人操作）
        oldmanIdNameUnshift: [], //用于解绑时 添加老人操作
        oldIdCard: [], //老人身份证
        oldmanList: [], //老人所有信息列表
        formInline: {
          inputdeviceno: "",
        },
        //绑定位置 ， 自定义 老人和床位
        dialogFormBangdi: false,
        locationShow: false, //绑定床位的input 和 span 显示和隐藏的切换
        oldManShow: true, //选择老人的显示和隐藏
        bedShow: false, //选择床位信息的显示和隐藏
        roomShow:false,
        location: "", //如果是绑定类型为床位绑定   就把Cascader级联选择器选择的楼栋 层数 房间 床位  回显放到location绑定的位置 
        cascadervalue: [], //Cascader级联选择器集合的值默认为空
        optionsBed: [], //床位号的Cascader级联选择器集合
        optionsRoom:[], //房间号的集合
        bindType: 1, //设备绑定的类型 默认绑定床位
        formBangdi: {
          location: "", //绑定的位置
          oldmanName: "", //老人姓名
          oldmanId: "", //老人id
          deviceId: "", //设备id
          oldIdCard: "", //老人身份证编号
          bedId: "", //床位id
          roomId: "",
          bindDeviceNo: "", //绑定模态框弹出的设备编号
        },
        // 新增表单dialog
        dialogFormVisible: false,
        dialogVisible: false,
        form: {
          xzdate: "",
          xzsec: "",
          xzname: "",
        },
        formLabelWidth: "120px",
        //修改表单dialog
        dialogFormEdit: false,
        formedit: {
          editdate: "",
          editname: "",
          editsec: "",
          // editaddress:'',
        },
        rules: {
          // 新增正则验证匹配规则
          xzdate: [
            {
              required: true, //是否必填
              message: "不能为空", //规则
              trigger: "blur", //何事件触发
            },
            { min: 1, max: 30, message: "长度在 1到 30 个字符" }, //by  guo 2020-4-26-18:12修改
          ],
          xzsec: [
            { min: 1, max: 100, message: "长度在 1到 100 个字符" },
          ],
          xzname: [
            { min: 1, max: 30, message: "长度在 1到 30 个字符" },
          ],
          editdate: [
            {
              required: true, //是否必填
              message: "不能为空", //规则
              trigger: "blur", //何事件触发
            },
            { min: 1, max: 30, message: "长度在 1到 30 个字符" }, //by  guo 2020-4-26-18:12修改
          ],
          editsec: [
            { min: 1, max: 100, message: "长度在 1到 100 个字符" },
          ],
          editname: [
            { min: 1, max: 30, message: "长度在 1到 30 个字符" },
          ],
          location: [
            {
              required: true, //是否必填
              message: "不能为空", //规则
              trigger: "blur", //何事件触发
            },
            { min: 1, max: 15, message: "长度在 1到 15 个字符" },
          ],
          oldmanId: [
            {
              required: true, //是否必填
              message: "不能为空", //规则
              trigger: "change", //何事件触发
            },
          ],
          bedId: [
            {
              required: true, //是否必填
              message: "还未选择床位", //规则
              trigger: "change", //何事件触发
            },
          ],
        },
        fileFlag: false,
      };
    },
    methods: {
      //选中行
      handleSelectionChange(val) {
        console.log("val:", val);
      },
      //点击查询
      onSubmit() {
        if (this.formInline.inputdeviceno == "") {
          this.getTableData(this.formInline.inputdeviceno, (this.pageNum = 1));
        } else {
          this.getTableData(
            this.formInline.inputdeviceno,
            (this.pageNum = 1),
            (this.pageSize = 10)
          );
        }
      },
  
      //键盘事件 按下键盘回车 查询
      enterSearchMember(e) {
        console.log("回车搜索", keyCode, e);
        var keyCode = window.event ? e.keyCode : e.which;
        if (keyCode == 13 && this.formInline.inputdeviceno != null) {
          if (this.formInline.inputdeviceno == "") {
            this.getTableData(this.formInline.inputdeviceno, (this.pageNum = 1));
          } else {
            this.getTableData(
              this.formInline.inputdeviceno,
              (this.pageNum = 1),
              (this.pageSize = 10)
            );
          }
        }
      },
  
      // 修改table tr行的背景色
      tableRowStyle({ row, rowIndex }) {
        if (rowIndex % 2 == 0) {
          return "background-color: #ffffff";
        } else {
          return "background-color: #e4f5f8";
        }
      },
      // 修改table header的背景色
      tableHeaderColor({ row, column, rowIndex, columnIndex }) {
        if (rowIndex === 0) {
          return "color:#2d2d2d;font-weight: 600; text-align: center;font-size: 16px;background-color: #d4f5fa;";
        }
      },
      //弹出框下拉菜单change事件  by guo 2019-11-19-17:53修改  需求变更  按钮绑定由一个老人对一个按钮  变更为一个老人对多个按钮
      currentSel(selVal) {
        this.formBangdi.oldmanId = selVal;
        this.formBangdi.bedId = null;
        this.formBangdi.location = "";
        this.selectOldmanList.forEach((item, index) => {
          if (this.formBangdi.oldmanId == item.oldmanId) {
            this.formBangdi.oldIdCard = item.oldIdCard;
            this.formBangdi.bedId = item.bedId;
            this.formBangdi.location = item.bedNo;
            this.location = item.bedNo;
          }
        });
      },
  
      //关闭绑定dialog  重置
      closeBangdi() {
        this.dialogFormBangdi = false;
        this.cascadervalue = []; //绑定成功后清空Cascader级联选择器框的值
        this.locationBedShow = "暂无数据";
        this.$refs.formBangdi.clearValidate(); //移除校验结果并重置字段值
        if (this.bindType != 0) {
          //点击取消关闭 重置dialog的状态
          this.bindType = 0;
          this.oldManShow = false;
          this.bedShow = false;
          this.roomShow = false;
          this.locationShow = true;
          this.$set(this.rules, "location", [
            {
              required: true, //是否必填
              message: "不能为空", //规则
              trigger: "blur", //何事件触发
            },
            {
              min: 1,
              max: 30,
              message: "长度在 1到 30 个字符",
            },
          ]);
        }
      },
  
      //取消  弹出框关闭
      cancelBangdi() {
        this.dialogFormBangdi = false;
        this.cascadervalue = []; //绑定成功后清空Cascader级联选择器框的值
        this.locationBedShow = "暂无数据";
        this.$refs.formBangdi.clearValidate(); //移除校验结果并重置字段值
        if (this.bindType != 0) {
          //点击取消关闭 重置dialog的状态
          this.bindType = 0;
          this.oldManShow = false;
          this.bedShow = false;
          this.roomShow = false;
          this.locationShow = true;
          this.$set(this.rules, "location", [
            {
              required: true, //是否必填
              message: "不能为空", //规则
              trigger: "blur", //何事件触发
            },
            {
              min: 1,
              max: 30,
              message: "长度在 1到 30 个字符",
            },
          ]);
        }
      },
  
      //绑定紧急按钮  弹出模态框
      handleBangdi(index, row) {
        //点击绑定打开dialog 在清除input绿色框  先判断是否为undefined
        if (this.$refs["formBangdi"] != undefined) {
          this.$nextTick(() => {
            this.$refs["formBangdi"].resetFields();
          });
        }
        console.log(index, row);
        this.dialogFormBangdi = true;
        this.formBangdi = Object.assign({}, row); //深拷贝数据
        console.log(this.formBangdi.id);
        this.formBangdi.deviceId = this.formBangdi.id;
        this.formBangdi.bindDeviceNo = this.formBangdi.deviceNo;
        // this.$router.push({path:'/bangdibutton',query:{id:id}});//编程式导航跳转  query传参
        //点击绑定时弹出dialog,然后循环判断select菜单已经绑定的老人，如果已经绑定就将其移除
        this.allList.forEach((item, index) => {
          console.log(item, index);
          this.oldmanNameIdList.forEach((item2, index2) => {
            // console.log(item2,index2);
            //通过老人的oldmanId和已经绑定的状态 bind  true为绑定  fasle为解绑   来进行判断
            if (item2.oldmanId == item.oldmanId && item.bind == true) {
              this.oldmanNameIdList.splice(index2, 1); //删除数组中对应的值
            }
          });
        });
        console.log(this.oldmanNameIdList);
      },
  
      //选取的当前的楼栋 层 房间
      handleItemChange(val) {
        console.log("active item:", val);
      },
      handleChangeRoom(val){
        if (val.length == 3) {
          var refbedStr = "";
          this.$refs.refRoom
            .getCheckedNodes()[0]
            .pathLabels.forEach((item, index) => {
              //判断字符串拼接最后一位不加 "-"
              if (
                this.$refs.refRoom.getCheckedNodes()[0].pathLabels.length - 1 ==
                index
              ) {
                refbedStr += item;
              } else {
                refbedStr += item + "-";
              }
            });
            this.formBangdi.location = refbedStr;
            this.formBangdi.roomId = val[2]; //获取房间roomId
        }
      },
      //选取的床位
      handleChangeBed(val) {
        this.formBangdi.bedId = val[3]; //获取房间roomId
        if (val.length == 4) {
          var refbedStr = "";
          this.$refs.refbed
            .getCheckedNodes()[0]
            .pathLabels.forEach((item, index) => {
              //判断字符串拼接最后一位不加 "-"
              if (
                this.$refs.refbed.getCheckedNodes()[0].pathLabels.length - 1 ==
                index
              ) {
                refbedStr += item;
              } else {
                refbedStr += item + "-";
              }
            });
          this.location = refbedStr; //把获取的床位信息回显到location位置
          console.log(refbedStr);
          console.log(this.location);
          //通过床位查找老人id,判断该床位是否有老人入住
          if (this.formBangdi.bedId) {
            //判断床位是否被选中 ,选中了才赋值  发起数据请求
            let param = {
              bedId: this.formBangdi.bedId,
            };
            console.log(param);
            this.$postForm("omc/Bed/selectByBedId", param).then((res) => {
              console.log(res);
              if (res.result.oldmanId != null) {
                this.formBangdi.oldmanId = res.result.oldmanId;
                this.formBangdi.oldmanName = res.result.oldName;
              } else {
                this.formBangdi.oldmanId = null;
                this.formBangdi.oldmanName = null;
              }
            });
          }
        } else {
          this.location = "暂无数据";
        }
      },
  
      //设备绑定提交数据
      submitFormBangdi(datainfo) {
        //循环判断 取出对应的oldmanId和oldmanName
        console.log(this.formBangdi);
  
        if (this.selectOldmanList) {
          this.selectOldmanList.forEach((item, index) => {
            if (this.formBangdi.oldmanId == item.oldmanId) {
              this.formBangdi.oldmanName = item.oldName;
            }
          });
        }
  
        this.$refs[datainfo].validate((valid) => {
          if (valid) {
            let param = "";
            // if(this.bindType == 0){ //自定义
            //   param = {
            //     deviceId: this.formBangdi.deviceId,
            //     bindType: this.bindType,
            //     location: this.formBangdi.location,
            //   };
            // }else if (this.bindType == 1){
            //   param = {
            //     deviceId: this.formBangdi.deviceId,
            //     bindType: this.bindType,
            //     location: this.formBangdi.location,
            //     oldmanId: this.formBangdi.oldmanId,
            //     oldmanName: this.formBangdi.oldmanName,
            //   };
            // }else if (this.bindType == 2){
            //   param = {
            //     deviceId: this.formBangdi.deviceId,
            //     bindType: this.bindType,
            //     location: this.locationBedShow,
            //     oldmanId: this.formBangdi.oldmanId,
            //     oldmanName: this.formBangdi.oldmanName,
            //     bedId: this.formBangdi.bedId,
            //   };
            // }else if (this.bindType == 3){
            //   param = {
            //     deviceId: this.formBangdi.deviceId,
            //     bindType: this.bindType,
            //     location: this.formBangdi.location,
            //     roomId: this.formBangdi.roomId,
            //   };
            // }
            param = {
                deviceId: this.formBangdi.deviceId,
                bindType: this.bindType,
                location: this.formBangdi.location||"",
                oldmanId: this.formBangdi.oldmanId||"",
                oldmanName: this.formBangdi.oldmanName||"",
                bedId: this.formBangdi.bedId||"",
                roomId: this.formBangdi.roomId||"",
              };
            console.log(param);
            this.$postJson("dmc/commonDevice/bindLocation", param).then(
              (res) => {
                this.dialogFormBangdi = false;
                if (res.code == "10061031") {
                  setTimeout(() => {
                    this.$message({
                      message: "设备已经梆定",
                      type: "error",
                    });
                  }, 300);
                } else if (res.code == "10061065") {
                  setTimeout(() => {
                    this.$message({
                      message: res.message,
                      type: "error",
                    });
                  }, 300);
                } else {
                  this.cascadervalue = []; //绑定成功后清空Cascader级联选择器框的值
                  this.location = "暂无数据"; //重置span位置信息
                  //绑定成功重置dialog的状态
                  this.bindType = 0;
                  this.oldManShow = false;
                  this.bedShow = false;
                  this.roomShow = false;
                  this.locationShow = true;
                  console.log(this.formedit.status);
                  setTimeout(() => {
                    this.$message({
                      message: res.message,
                      type: "success",
                    });
                    this.getTableData();
                  }, 300);
                }
              }
            );
          }
        });
      },
      //解绑
      handleJiebang(index, row) {
        console.log(index, row);
        var list = []; //声明一个空数组，用于存储解绑的老人信息
        //循环另一个集合  判断取到对应的老人信息
        if (row.oldmanId != null) {
          this.oldmanIdNameUnshift.forEach((item, index) => {
            console.log(item, index);
            console.log(row.oldmanId);
            if (row.oldmanId == item.oldmanId) {
              var obj = {};
              obj.oldName = item.oldName;
              obj.oldmanId = item.oldmanId;
              obj.oldIdCard = item.oldIdCard;
              list.push(obj);
            }
          });
        }
        console.log(list);
        console.log(row);
        this.$confirm("此操作将解除绑定, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          center: true,
          closeOnClickModal: false,
        })
          .then(() => {
            this.formBangdi = Object.assign({}, row); //深拷贝数据
            let deviceId = this.formBangdi.id;
            this.$postJson("dmc/commonDevice/unBindLocation/" + deviceId).then(
              (res) => {
                //先判断绑定类型是否为 1  老人类型   为老人类型才循环添加值
                if (
                  row.oldmanId != null &&
                  row.oldmanName != "" &&
                  list.length > 0
                ) {
                  //by guo 2019-5-7添加 判断list.length>0 list数组不为空
                  //通过循环判断解绑的老人oldmanId ,将解绑的老人信息 再重新添加进oldmanNameIdList的集合中  使其在select下拉菜单老人列表中显示出来
                  this.allList.forEach((item, index) => {
                    //console.log(item,index);
                    console.log(item.oldmanId == row.oldmanId);
                    if (item.oldmanId == row.oldmanId) {
                      this.oldmanNameIdList.unshift(list[0]);
                    }
                  });
                }
                //数组中的对象去重，因为在老人列表修改
                let obj = {};
                this.oldmanNameIdList = this.oldmanNameIdList.reduce(
                  (cur, next) => {
                    obj[next.oldName]
                      ? ""
                      : (obj[next.oldName] = true && cur.push(next));
                    return cur;
                  },
                  []
                ); //设置cur默认类型为数组，并且初始值为空的数组
                console.log(this.oldmanNameIdList);
                console.log(res);
                this.$set(this.formedit, "status", true);
                if (res.code == "10061032") {
                  setTimeout(() => {
                    this.$message({
                      message: "设备尚未绑定",
                      type: "error",
                    });
                    this.getTableData();
                  }, 300);
                } else {
                  setTimeout(() => {
                    this.$message({
                      message: res.message,
                      type: "success",
                    });
                    this.getTableData();
                  }, 300);
                }
              }
            );
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消解绑",
            });
          });
      },
      //绑定类型radio,当类型radio值为1时，让房间下拉菜单显示
      changeRadioBindType(value) {
        console.log(value);
        if (value == 0) {
          this.oldManShow = false;
          this.bedShow = false;
          this.locationShow = true;
          this.roomShow = false;
          this.$set(this.rules, "location", [
            {
              required: true, //是否必填
              message: "不能为空", //规则
              trigger: "blur", //何事件触发
            },
            {
              min: 1,
              max: 30,
              message: "长度在 1到 30 个字符",
            },
          ]);
          this.formBangdi.location = null; //选取自定义时清空位置信息
          this.formBangdi.oldmanName = null; //选取自定义时清空老人信息
          this.formBangdi.oldIdCard = null; //选取自定义时清空老人身份证
          this.formBangdi.bedId = null; //选取自定义时清空房间的信息
          this.formBangdi.roomId = null; //选取自定义时清空房间的信息
          this.location = "暂无数据"; //选取自定义时清空绑定位置信息
          this.$refs.formBangdi.clearValidate(); //移除校验结果并重置字段值
        } else if (value == 1) {
          this.oldManShow = true;
          this.bedShow = false;
          this.roomShow = false;
          //this.locationShow=true;
          this.locationShow = false; //by guo 2020-7-3-16:54修改 查询老人的接口变更  都是入院老人  老人肯定有床位  因此不需要自定义输入老人的位置
          this.$set(this.rules, "location", [
            { min: 0, max: 30, message: "长度在 0到 30 个字符" },
          ]);
          this.formBangdi.oldmanId = null; //选取老人时清空位置信息
          this.formBangdi.location = null; //选取老人时清空位置信息
          this.formBangdi.bedId = null; //选取老人时清空房间的信息
          this.formBangdi.roomId = null; //选取自定义时清空房间的信息
          this.location = "暂无数据"; //选取老人时清空绑定位置信息
          this.$refs.formBangdi.clearValidate(); //移除校验结果并重置字段值
        } else if (value == 2) {
          this.oldManShow = false;
          this.bedShow = true;
          this.roomShow = false;
          this.locationShow = false;
          this.formBangdi.location = null; //选取床位时清空位置信息
          this.formBangdi.oldmanName = null; //选取床位时清空老人信息
          this.formBangdi.oldIdCard = null; //选取床位时清空老人身份证
          this.$refs.formBangdi.clearValidate(); //移除校验结果并重置字段值
        }else if (value == 3) {
          this.oldManShow = false;
          this.bedShow = false;
          this.locationShow = true;
          this.roomShow = true;
          this.formBangdi.location = null; //选取床位时清空位置信息
          this.formBangdi.oldmanName = null; //选取床位时清空老人信息
          this.formBangdi.oldIdCard = null; //选取床位时清空老人身份证
          this.$refs.formBangdi.clearValidate(); //移除校验结果并重置字段值
        }
      },
      // 点击弹出修改信息的弹窗
      handleEdit(index, row) {
        (this.dialogFormEdit = true), //打开修改弹窗
          console.log(index, row);
        this.listIndex = index; //记录索引
        console.log(this.listIndex);
        //this.formedit=row;//记录数据
        this.formedit = Object.assign({}, row); //深拷贝记录
        console.log(this.formedit.id);
        //将对应行所对的表格值赋给input框
        this.$set(this.formedit, "editdate", row.deviceNo);
        this.$set(this.formedit, "editsec", row.remark);
        this.$set(this.formedit, "editname", row.deviceName);
        console.log(this.formedit.editdate);
      },
      //点击修改弹窗的 确定按钮提交修改的数据
      submitFormEdit(datainfo) {
        //正则匹配规则rules
        this.$refs[datainfo].validate((valid) => {
          //判断数据是否存在
          if (valid) {
            let param = {
              id: this.formedit.id,
              remark: this.formedit.editsec,
              deviceName: this.formedit.editname,
              deviceNo: this.formedit.editdate,
            };
            console.log(param);
            this.editLoading = true;
            this.$postJson("dmc/commonDevice/edit", param)
              .then((res) => {
                console.log(res);
                this.editLoading = false;
                this.dialogFormEdit = false; //关闭修改弹窗
                if (res.code == "200") {
                  setTimeout(() => {
                    this.$message({
                      message: res.message,
                      type: "success",
                    });
                    this.getTableData();
                  }, 300);
                  console.log("修改成功!");
                } else {
                  setTimeout(() => {
                    this.$message({
                      message: res.message,
                      type: "error",
                    });
                  }, 300);
                }
              })
              .catch((res) => {
                this.$message({
                  type: "error",
                  message: res.message,
                });
              });
          } else {
            console.log("修改失败!");
            return false;
          }
        });
      },
  
      //删除
      handleDelete(index, row) {
        console.log(row);
        if (row.status == null || row.status == true) {
          this.$confirm("此操作将永久删除该内容, 是否继续?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
            center: true,
            closeOnClickModal: false,
          })
            .then(() => {
              console.log(index, row);
              let id = row.id;
              console.log(id);
              this.$postJson("dmc/commonDevice/deleteById/"+id).then((res) => {
                //旧 dmc/button/deleteById/
                if (res.code == 200) {
                  console.log(res);
                  this.$message({
                    type: "success",
                    message: res.message,
                  });
                  this.getTableData();
                } else {
                  this.$message({
                    type: "error",
                    message: res.message,
                  });
                }
              });
            })
            .catch(() => {
              this.$message({
                type: "info",
                message: "已取消删除",
              });
            });
        } else {
          this.$message({
            type: "error",
            message: "该设备已经被绑定，请先解绑后再进行删除!",
          });
        }
      },
  
      //关闭新增的dialog
      closexz() {
        this.$refs.form.resetFields(); //移除校验结果并重置字段值
      },
      //点击新增取消  重置表单以及验证
      cancelxz() {
        this.dialogFormVisible = false;
        this.$refs.form.resetFields(); //移除校验结果并重置字段值
      },
      // 新增弹出框点击确定提交信息
      submitForm(datainfo) {
        this.$refs[datainfo].validate((valid) => {
          if (valid) {
            let param = {
              remark: this.form.xzsec,
              deviceName: this.form.xzname,
              deviceNo: this.form.xzdate,
              deviceType:10
            };
            console.log(param);
            this.addLoading = true;
            this.$postJson(
              "dmc/commonDevice/add",
              param
            ).then((res) => {
              //旧：dmc/button/add
              console.log(res);
              this.addLoading = false;
              this.dialogFormVisible = false;
              this.$refs.form.resetFields(); //移除校验结果并重置字段值
              if (res.code == "200") {
                setTimeout(() => {
                  this.$message({
                    message: res.message,
                    type: "success",
                  });
                  this.getTableData();
                }, 300);
                console.log("提交成功!");
              } else {
                setTimeout(() => {
                  this.$message({
                    message: res.message,
                    type: "error",
                  });
                }, 300);
              }
            });
          } else {
            console.log("提交失败!");
            return false;
          }
        });
      },
  
      //获取分页的紧急按钮数据  只获取pageSize条数据
      getTableData() {
        let param = {
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          deviceNo: this.formInline.inputdeviceno,
          deviceType: 8,//按钮
        };
        this.loading = true;
        this.$postJson("dmc/commonDevice/queryDeviceListWithPage", param).then(
          (res) => {
            //判断是否有数据
            if (res.result.list.length != 0) {
              this.pageSize = res.result.pageSize;
              this.currentPage = res.result.pageNum;
              this.totalDataNumber = res.result.total * 1;
              this.list = res.result.list;
              res.result.list.forEach((item, index) => {
                if (item.location == null){
                  this.$set(item, "status", true);
                }else if (item.location!='' || item.oldmanName!='' ) {
                  this.$set(item, "status", false); //已绑定
                }else {
                  this.$set(item, "status", true);
                }
              });
              setTimeout(() => {
                this.loading = false;
              }, 200);
            } else {
              this.list = [];
              this.totalDataNumber = 0;
              setTimeout(() => {
                this.loading = false;
              }, 1000);
            }
          }
        );
      },
      handleSizeChange(val) {
        //改变每页显示的条数
        this.PageSize = val;
        this.getTableData();
      },
      handleCurrentChange(val) {
        this.pageNum = val;
        this.getTableData();
      },
    },
    created() {
      //组件创建完后获取数据，
      //此时 data 已经被 observed 了
      this.getTableData();
    },
    mounted() {
    },
  };
  </script>
  <style lang="scss" scoped>
  .buttonlist {
    .buttonlist-m {
      padding: 10px 0 0 5px;
    }
  }
  // 修改element-ui默认的样式
  .del {
    color: red !important;
  }
  .fangqu {
    color: green !important;
  }
  .fenye {
    margin: 0;
    padding: 30px 0;
    background: #fff;
  }
  //  ::v-deep深度作用选择符
  ::v-deep .el-dialog__header {
    text-align: left;
    background: rgb(238, 231, 231);
    border-bottom: 2px solid rgb(211, 207, 207);
  }
  //新增的dialog
  @media screen and (min-width: 1200px) {
    ::v-deep .dangerbuttonxz .el-dialog {
      width: 30% !important;
    }
  }
  //修改的dialog
  @media screen and (min-width: 1200px) {
    ::v-deep .dangerbuttonedit .el-dialog {
      width: 30% !important;
    }
  }
  //绑定紧急按钮位置和房间的dialog
  @media screen and (min-width: 1200px) {
    ::v-deep .bangdilocation .el-dialog {
      width: 30% !important;
    }
  }
  @media screen and (min-width: 600px) and (max-width: 1199px) {
    ::v-deep .bangdilocation .el-dialog {
      width: 55% !important;
    }
  }
  </style>